import React from 'react'
import "./Whyus.css"
import { TfiLayoutLineSolid } from "react-icons/tfi";
import { IoShieldOutline } from "react-icons/io5";
import { IoPersonOutline } from "react-icons/io5";
import { PiHouseSimpleLight } from "react-icons/pi";
import { SiTrustpilot } from "react-icons/si";
import About2
 from '../About2/About2';


const Whyus = () => {
    return (
        <div className='whyus-main' id='why'>
            <div className="whyus-container">
                <div className="whyus-top">
                    <div className="whyus-head">
                        <span><TfiLayoutLineSolid />Why Profi1 Station
                        </span>
                    </div>
                    <div className="whyus-text">
                        <p>A local desk, a national backbone.</p>
                    </div>
                </div>
                <div className="whyus-bottom">
                    <div className="why-1">
                        <div className="why-icon">
                            <span><IoShieldOutline /></span>
                        </div>
                        <div className="why-about">
                            MOFSL-backed trust
                        </div>
                        <div className="why-tag">
                            <p>Every recommendation sits on Motilal Oswal's research and compliance infrastructure — not a standalone shop.</p>
                        </div>
                    </div>


                    <div className="why-1">
                        <div className="why-icon">
                            <span><IoPersonOutline /></span>
                        </div>
                        <div className="why-about">
                            Personal advisory
                        </div>
                        <div className="why-tag">
                            <p>You speak with someone who knows your portfolio, not a call-centre queue.</p>
                        </div>
                    </div>


                    <div className="why-1">
                        <div className="why-icon">
                            <span><PiHouseSimpleLight /></span>
                        </div>
                        <div className="why-about">
                            A Patiala presence
                        </div>
                        <div className="why-tag">
                            <p>Meet face to face when it matters — a real local office, not just a support ticket.</p>
                        </div>
                    </div>


                    <div className="why-1">
                        <div className="why-icon">
                            <span><SiTrustpilot /></span>
                        </div>
                        <div className="why-about">
                            MOFSL-backed trustPlain-language reporting
                        </div>
                        <div className="why-tag">
                            <p>Statements and reviews explained in terms you can actually act on.</p>
                        </div>
                    </div>
                </div>
            </div>
            <About2/>
        </div>
    )
}

export default Whyus